import INVENTORY_API_BASE_URL from "../../config/api";
import { useState, useEffect } from "react";
import Axios from "axios";
import "./CreateExtraBarcode.css";
import swal from "sweetalert";
import Table from "react-bootstrap/esm/Table";
import Magnifier from "react-magnifier";
import alertify from "alertifyjs";

function CreateExtraBarcode() {
  const [list, setlist] = useState([]);
  const [list1, setlist1] = useState([]);
  const [filterText, setFilterText] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [PO, setPO] = useState([]);
  const [skuCounts, setSkuCounts] = useState({});
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);

  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/getlist`).then((response) => {
      const allData = response.data;
      const activeData = allData.filter((form) => form.AuthStatus === "active");
      setFilteredData(activeData);
      setlist(activeData);
    });
  }, []);

  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/getOrder`).then((response) => {
      setlist1(response.data);
    });
  }, []);

  const handleInputChange = (sku, column, value, row) => {
    const index = list.findIndex((rowData) => rowData.sku === sku);
    const newTableData = [...list];
    newTableData[index][column] = value;

    if (!selectedCheckboxes.includes(sku)) {
      swal("Please select the checkbox first", "", "warning");
      return;
    }

    if (column === "quantity") {
      const quantity = parseInt(value);
      const purchasePrice = parseFloat(newTableData[index].purchasePrice);
      newTableData[index].total = quantity * purchasePrice;
    }


    const abc = `${row.sku.substring(0, 5)}-0`;
    newTableData[index].batchid = abc;

    setlist(newTableData);
  };

  const handleFilter = () => {
    if (filterText.trim() === "") {
      setFilteredData(list);
    } else {
      const filteredList = list.filter(
        (form) =>
          form.sku.toLowerCase().includes(filterText.toLowerCase()) ||
          form.title.toLowerCase().includes(filterText.toLowerCase())
      );
      setFilteredData(filteredList);
    }
  };

  const handleCheckboxChange = (event) => {
    const { value } = event.target;
    const selectedlist = list.find((listdata) => listdata.sku === value);

    if (event.target.checked) {
      setSelectedCheckboxes([...selectedCheckboxes, value]);
      setPO([...PO, selectedlist]);
    } else {
      setSelectedCheckboxes(
        selectedCheckboxes.filter((checkbox) => checkbox !== value)
      );
      setPO(PO.filter((listdata) => listdata.sku !== selectedlist.sku));
    }
  };

  function handleSubmit() {
    if (selectedCheckboxes.length === 0) {
      alertify("Please select the checkbox and fill it's Details");
      return;
    }

    const missingDetailsItems = PO.filter(
      (item) => !item.purchasePrice || !item.quantity
    );

    if (missingDetailsItems.length > 0) {

      swal({
        title: "Please fill input field",
        text: "",
        icon: "error",
      });
      return;
    }

    Axios.post(`${INVENTORY_API_BASE_URL}/POgivenn`, PO)
      .then((result) => {
      })
      .catch((error) => {
        alertify("service error");
      });
    swal({
      title: "Purchase Order Created",
      text: "",
      icon: "success",
    }).then(() => {
      window.location.reload();
    });
  }

  function handleRowClick() {
    const skuCountMap = {};
    list1.forEach((item) => {
      item.list.forEach((subItem) => {
        const sku = subItem.sku;
        if (skuCountMap[sku]) {
          skuCountMap[sku] += 1;
        } else {
          skuCountMap[sku] = 1;
        }
      });
    });
    setSkuCounts(skuCountMap);
  }

  return (
    <div className="POcreation">
      <h4 className="POheading">Create Purchase Order for Extra Books</h4>
      <div className="pocrat">
        <input
          type="text"
          placeholder="Enter SKU or Title to filter..."
          value={filterText}
          onChange={(e) => setFilterText(e.target.value)}
        />
        <button onClick={handleFilter}>Filter</button>
      </div>

      <div className="container5">
        <div className="content">
          <Table className="createtable">
            <thead>
              <tr>
                <th></th>
                <th>SKUCode</th>
                <th>Image</th>
                <th>Title</th>
                <th>Printing price</th>
                <th>Order Quantity</th>
                <th>Medium</th>
                <th>Edition</th>
                <th>Current Stock</th>
                <th>MRP</th>
                <th>Order Value</th>
                <th>Batch ID</th>
              </tr>
            </thead>

            <tbody className="pirfon">
              {filteredData.map((row) => (
                <tr key={row.sku} onClick={handleRowClick}>
                  <td>
                    <input
                      className="checkboxpo"
                      type="checkbox"
                      name="listdata"
                      value={row.sku}
                      onChange={handleCheckboxChange}
                      checked={selectedCheckboxes.includes(row.sku)}
                    />
                  </td>
                  <td>{row.sku}</td>
                  <td>
                    <div
                      style={{ position: "relative", display: "inline-block" }}
                    >
                      <Magnifier
                        src={`${INVENTORY_API_BASE_URL}/${row.img}`}
                        width={70}
                        height={70}
                        mgShape="square"
                        mgWidth={650}
                        mgHeight={650}
                        mgMouseOffsetX={234}
                        mgMouseOffsetY={234}
                        mgShowOverflow
                      />
                    </div>
                  </td>
                  <td>{row.title}</td>
                  <td>
                    <input
                      type="number"
                      value={row.purchasePrice}
                      onChange={(e) =>
                        handleInputChange(
                          row.sku,
                          "purchasePrice",
                          e.target.value,
                          row
                        )
                      }
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      value={row.quantity}
                      onChange={(e) =>
                        handleInputChange(
                          row.sku,
                          "quantity",
                          e.target.value,
                          row
                        )
                      }
                    />
                  </td>
                  <td>{row.Medium}</td>

                  <td>{row.edition}</td>
                  <td>{row.stock}</td>
                  <td>{row.mrp}</td>

                  <td>
                    {row.total !== undefined
                      ? row.total.toFixed(2)
                      : (row.quantity * row.purchasePrice).toFixed(2)}
                  </td>
                  <td>
                    {row.sku.substring(0, 5)}-{skuCounts[row.sku] || 0}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>

      <div>
        <button type="submit" className="POcreationbtn" onClick={handleSubmit}>
          Save Order
        </button>
      </div>
    </div>
  );
}

export default CreateExtraBarcode;
